var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.user.premium && _vm.enableAds)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('AdViewInner',{attrs:{"id":_vm.id}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }